// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__366CM","largestCol":"styles_largestCol__VkByC","smallestCol":"styles_smallestCol__3EmrW"};